import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableReCaptchaMemberTopUp',
  initialState: false,
  reducers: {
    setEnableReCaptchaMemberTopUp(_state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableReCaptchaMemberTopUp } = slice.actions;

export default slice.reducer;
